<template>
    <div :uk-tooltip="tooltip ? 'title:' + tooltip : ''">
        <div
            :class="
                'cursor-initial uk-label uk-label-' + mode + generateClasses()
            ">
            <div class="uk-flex uk-flex-middle">
                <Icon v-if="icon" :icon="icon" class="icon" />
                {{ text }}
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
import Icon from './Icon';

export default {
    name: 'LabelV2',
    components: {Icon},
    props: {
        mode: String,
        text: [String, Number],

        icon: String,
        tooltip: String,

        isMedium: Boolean,
        isLarge: Boolean,
        isMax: Boolean,
        isSmall: Boolean,
        isRound: Boolean,
    },
    methods: {
        generateClasses() {
            let classes = '';

            if (this.isMedium) {
                classes += ' medium';
            }

            if (this.isLarge) {
                classes += ' large';
            }

            if (this.isSmall) {
                classes += ' small';
            }

            if (this.isMax) {
                classes += ' uk-width-expand';
            }

            if (this.isRound) {
                classes += ' round';
            }

            return classes;
        },
    },
};
</script>

<style lang="scss" scoped>
.uk-label {
    font-size: 14px !important;
    padding: 4px 15px 4px 15px !important;
}

.round {
    border-radius: $border-radius-next !important;
}

.uk-label-default {
    background-color: transparent;
    color: #333;
    border: 1px solid #e5e5e5;
}

.large {
    font-size: 17px !important;
    padding: 6px 30px 6px 30px !important;
    font-weight: 500 !important;
}

.small {
    padding: 3px 5px 3px 5px !important;
}

.medium {
    font-size: 16px !important;
    padding: 4px 20px 4px 20px !important;
}

.icon {
    margin-right: 5px;
}

.uk-label- {
    &success {
        background-color: $success-color !important;
        color: #fff !important;
        border: 1px solid $success-color;
    }

    &warning {
        background-color: $warning-color !important;
        color: #fff !important;
        border: 1px solid $warning-color;
    }

    &white {
        background-color: #fff !important;
        color: #333 !important;
        border: 1px solid #fff;
    }

    &blank {
        background-color: inherit;
        color: $site-color !important;
        border: 1px solid inherit;
    }

    &secondary {
        background-color: #222 !important;
        color: $site-color !important;
        border: 1px solid #222;
    }
}
</style>
